/**
 * Shared helpers for Lumis Experience `lum_track` (safe emit when the portal injects late).
 * Used by home carousels, Allos top bar analytics, and other surfaces loaded without a bundler.
 */
(function (window) {
  'use strict';

  var LUM_TRACK_POLL_MS = 150;
  var LUM_TRACK_WAIT_MS = 90000;

  /**
   * Poll until `probe()` returns non-null (sentinel for "not ready"). Then calls `onReady` with
   * that value. Stops after `timeoutMs`.
   */
  function pollUntil(probe, onReady, intervalMs, timeoutMs) {
    var first = probe();
    if (first !== null && first !== undefined) {
      onReady(first);
      return;
    }
    var deadline = Date.now() + timeoutMs;
    var timer = window.setInterval(function () {
      var result = probe();
      if (result !== null && result !== undefined) {
        window.clearInterval(timer);
        onReady(result);
        return;
      }
      if (Date.now() > deadline) {
        window.clearInterval(timer);
      }
    }, intervalMs);
  }

  function isLumTrackReady() {
    return typeof window.lum_track === 'function';
  }

  function safeLumTrack(eventId, data) {
    if (!isLumTrackReady()) {
      return;
    }
    try {
      window.lum_track('event', eventId, data);
    } catch (e) {
      /* lum_track unavailable or threw */
    }
  }

  /** Sends immediately, or polls until lum_track exists (portal injects it asynchronously). */
  function emitWhenReady(eventId, data) {
    pollUntil(
      function () {
        return isLumTrackReady() ? true : null;
      },
      function () {
        safeLumTrack(eventId, data);
      },
      LUM_TRACK_POLL_MS,
      LUM_TRACK_WAIT_MS
    );
  }

  /** Decode URI-encoded monitor field values from data-* attributes (e.g. banner name, top bar title). */
  function decodeURIComponentAttr(raw) {
    if (raw === null || raw === '') {
      return null;
    }
    try {
      return decodeURIComponent(raw);
    } catch (e) {
      return raw;
    }
  }

  window.AllosLumExperience = {
    pollUntil: pollUntil,
    isLumTrackReady: isLumTrackReady,
    safeLumTrack: safeLumTrack,
    emitWhenReady: emitWhenReady,
    decodeURIComponentAttr: decodeURIComponentAttr,
    LUM_TRACK_POLL_MS: LUM_TRACK_POLL_MS,
    LUM_TRACK_WAIT_MS: LUM_TRACK_WAIT_MS,
  };
})(window);
